import styled from "styled-components";
import Icon from "components/Icon";

export const SearchStyled = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  border: 1px solid #cccccc;
  width: 100%;
`;

export const SearchIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 35px;
  box-sizing: border-box;
  border: none;
  padding-left: 20px;
  font-size: 14px;

  &:focus {
    outline: none;
  }
`;
